<template>
  <div>
    <Main
      :loading="loading"
      :tableData="tableData"
      :disabled="disabled"
      @openDetailDialog="openDetailDialog"
      @batchDel="submitDel"
      ref="tableMain"
    >
      <Header
        ref="tableHeader"
        slot="header"
        :disabled="disabled"
        @openDetailDialog="openDetailDialog"
        @batchDel="$refs.tableMain.removeCheckboxRow()"
      />
    </Main>

    <el-dialog
      v-if="scheduleDetailDialogParams.visible"
      show-close
      :visible.sync="scheduleDetailDialogParams.visible"
      width="1000px"
      :title="scheduleDetailDialogParams.title"
      :close-on-click-modal="false"
      :before-close="() => (scheduleDetailDialogParams.visible = false)"
      v-el-dialog-drag
    >
      <DetailForm
        ref="detailForm"
        :disabled="scheduleDetailDialogParams.disabled"
        :userTripRequestCode="userTripRequestCode"
        :tripStartDate="tripStartDate"
        :tripEndDate="tripEndDate"
        :form="scheduleDetailDialogParams.form"
        :type="scheduleDetailDialogParams.type"
      />
      <span slot="footer">
        <el-button size="small" @click="close()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button
          type="primary"
          size="small"
          v-if="!scheduleDetailDialogParams.disabled"
          @click="save()"
        >
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Main from './main.vue'
import Header from './header.vue'
import DetailForm from '../components/detail'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: { Main, Header, DetailForm },
  props: {
    userTripRequestCode: { type: String, default: '' },
    tripStartDate: { type: String, default: '' },
    tripEndDate: { type: String, default: '' },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      scheduleDetailDialogParams: {
        visible: false,
        title: '',
        type: '',
        disabled: false,
        form: {}
      }
    }
  },
  created() {
    this.getData()
  },
  watch: {
    tableData: {
      handler() {
        this.updateDestinationCityName()
      },
      immediate: true
    }
  },
  methods: {
    getData() {
      if (!this.userTripRequestCode) return
      this.loading = true
      this.$api
        .userTripRequestScheduleListApi({
          userTripRequestCode: this.userTripRequestCode
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    openDetailDialog({ type, form = {} }) {
      if (!this.tripStartDate || !this.tripEndDate) {
        this.$message.warning(
          this.$l('tips_tripStartDate_or_tripEndDate_is_not_filled') ||
            '出差起始日 或 出差终止日未填写'
        )
        return
      }
      const types = {
        add:
          this.$l('dialog_title_add_travel_plan_information') ||
          '添加出差申请单行程计划信息',
        edit:
          this.$l('dialog_title_edit_travel_plan_information') ||
          '编辑出差申请单行程计划信息',
        detail:
          this.$l('dialog_title_travel_plan_details') ||
          '出差申请单行程计划详情'
      }
      if (!form.uuid) {
        form.uuid = this.getUUID()
      }
      this.scheduleDetailDialogParams = {
        visible: true,
        title: types[type],
        form,
        type: type,
        disabled: type === 'detail'
      }
    },
    batchDel() {
      const listCode = this.$refs.tableMain.getCheckboxRecords()
      if (listCode) this.submitDel(listCode)
    },
    submitDel(listCode) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning'
        }
      ).then(() => {
        this.$api
          .userTripRequestScheduleDelApi({
            userTripRequestScheduleCodeList: listCode,
            userTripRequestCode: this.userTripRequestCode
          })
          .then(() => {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success'
            })
            this.getData()
          })
      })
    },
    save() {
      this.$refs.detailForm.getForm().then((parms) => {
        if (!parms) return
        //校验行程计划中的时间
        if (this.checkTime(parms)) {
          this.$message.warning(
            this.$l('tips_travel_plan_date_exceeds_form_date') ||
              '行程计划日期超过申请单日期范围，请检查后重试'
          )
          return
        }
        for (let index = 0; index < this.tableData.length; index++) {
          if (parms.uuid === this.tableData[index].uuid) {
            this.$set(this.tableData, index, parms)
            this.close()
            return
          }
        }
        this.tableData.push(parms)
        this.close()
      })
    },
    close() {
      this.scheduleDetailDialogParams.visible = false
    },
    getTableData() {
      return this.tableData
    },
    checkTime(parms) {
      var stime = Date.parse(new Date(this.tripStartDate))
      var etime = Date.parse(new Date(this.tripEndDate))
      var scheduleStartDate = Date.parse(new Date(parms.scheduleStartDate))
      var scheduleEndDate = Date.parse(new Date(parms.scheduleEndDate))
      if (
        scheduleStartDate > etime ||
        scheduleStartDate < stime ||
        scheduleEndDate > etime ||
        scheduleEndDate < stime
      ) {
        return true
      }
      return false
    },
    //更新主表的出差目的地
    updateDestinationCityName() {
      var destinationCityName = Array.from(
        new Set(
          this.tableData.map((i) => i.destinationCityName).filter(Boolean)
        )
      ).join('、')

      var destinationCityCode = Array.from(
        new Set(
          this.tableData.map((i) => i.destinationCityCode).filter(Boolean)
        )
      ).join('、')
      this.$emit(
        'updateDestinationCityName',
        destinationCityName,
        destinationCityCode
      )
    },
    getUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8
        return v.toString(16)
      })
    }
  }
}
</script>
